import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  SAVE_HEDIS_CLAIM_REQUEST: '',
  SAVE_HEDIS_CLAIM_SUCCESS: '',
  SAVE_HEDIS_CLAIM_FAILURE: '',

  SAVE_CLAIM_STATUS_REQUEST: '',
  SAVE_CLAIM_STATUS_SUCCESS: '',
  SAVE_CLAIM_STATUS_FAILURE: '',

  VALIDATE_HEDIS_CLAIM_REQUEST: '',
  VALIDATE_HEDIS_CLAIM_SUCCESS: '',
  VALIDATE_HEDIS_CLAIM_FAILURE: '',

  SUBMIT_MEMBER_MEASURE_REQUEST: '',
  SUBMIT_MEMBER_MEASURE_SUCCESS: '',
  SUBMIT_MEMBER_MEASURE_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityClaimGenerator');

export default types;
